module.exports = __webpack_public_path__ + "static/media/liberia.1206855d.jpg";